<template>
  <div class="p-4">
    <h3 class="truncate text-xl text-neutral-500">
      {{ title }}
    </h3>
    <div
      v-for="timeFrame in statCardTimeFrames"
      :key="timeFrame"
    >
      <PlatformSummaryCardPeriod
        :title="timeFrameTitleMap[timeFrame]"
        :current-value="currentValues[timeFrame]"
        :previous-value="previousValues[timeFrame]"
        :loading="loading"
        :type="type"
        :currency="currency"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { MerchantCurrencyCode } from "@/utils/currency"

const statCardTimeFrames = ["day", "week", "month"] as const

type timeCategorisedStats = Record<
  (typeof statCardTimeFrames)[number],
  number | undefined
>

const timeFrameTitleMap: Record<
  (typeof statCardTimeFrames)[number],
  string
> = {
  day: "Today",
  week: "This Week",
  month: "This Month",
}

type Props = {
  title: string
  currentValues: timeCategorisedStats
  previousValues: timeCategorisedStats
  loading?: boolean
  type?: "number" | "currency"
  currency?: MerchantCurrencyCode
}

defineProps<Props>()
</script>
